'use client';

import { useEffect, useCallback } from 'react';
import { useSearchParams, usePathname, useRouter } from 'next/navigation';
import confetti from 'canvas-confetti';
import { toast } from 'react-toastify';

const SUCCESS_MESSAGES = {
  registration: 'Uspješno ste se prijavili na edukaciju! 🎓',
  'gift-card': 'Poklon bon je uspješno kupljen! 🎁',
  'gift-education': 'Edukacija je uspješno poklonjena! 🎁',
  default: 'Uspješna kupnja! 🎉',
};

const SuccessCelebration = () => {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();

  const fireConfetti = useCallback(() => {
    const duration = 3000;
    const end = Date.now() + duration;

    const colors = ['#6366f1', '#8b5cf6', '#d946ef', '#f43f5e', '#f97316', '#facc15'];

    const frame = () => {
      confetti({
        particleCount: 3,
        angle: 60,
        spread: 55,
        origin: { x: 0, y: 0.7 },
        colors,
      });

      confetti({
        particleCount: 3,
        angle: 120,
        spread: 55,
        origin: { x: 1, y: 0.7 },
        colors,
      });

      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    };

    // Initial burst
    confetti({
      particleCount: 100,
      spread: 100,
      origin: { y: 0.6 },
      colors,
    });

    frame();
  }, []);

  useEffect(() => {
    const success = searchParams.get('success');
    const type = searchParams.get('type');

    if (success !== 'true') return;

    // Only trigger on homepage or moj-profil
    if (pathname !== '/' && pathname !== '/moj-profil') return;

    // Fire confetti
    fireConfetti();

    // Show toast message
    const message = SUCCESS_MESSAGES[type] || SUCCESS_MESSAGES.default;
    toast.success(message, {
      autoClose: 5000,
      hideProgressBar: false,
    });

    // Clean up URL params after a short delay
    const timeout = setTimeout(() => {
      router.replace(pathname, { scroll: false });
    }, 500);

    return () => clearTimeout(timeout);
  }, [searchParams, pathname, router, fireConfetti]);

  return null;
};

export { SuccessCelebration };
